<script lang="ts">
	import Switch from '$lib/components/atoms/switch/Switch.svelte';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import { track } from '$lib/services/tracking/googleAnalytics';
	import * as m from '$paraglide/messages';

	interface Props {
		isTrafficPage: boolean;
	}

	const { isTrafficPage }: Props = $props();

	const { isTrafficInfoVisible, mapSettingsUserPreferencesLocalStorage } = getMapLayoutContext();

	function updateSwitchState() {
		$isTrafficInfoVisible = !$isTrafficInfoVisible;
		mapSettingsUserPreferencesLocalStorage.set('showTrafficLayer', $isTrafficInfoVisible);
		track({
			action: 'traffic_info_layer',
			payload: {
				action: $isTrafficInfoVisible ? 'on' : 'off',
				context: 'modal',
			},
		});
	}
</script>

<Switch
	id="traffic-info-switch"
	checked={$isTrafficInfoVisible}
	disabled={isTrafficPage}
	onchange={updateSwitchState}
>
	<div class="text-md">{m.map_tools__traffic_info__label()}</div>
</Switch>
